const WarehouseView = {
  INCOMING_ORDERS: "INCOMING_ORDERS",
  ORDERS_HISTORY: "ORDERS_HISTORY",
  WAREHOUSEMEN: "WAREHOUSEMEN",
  INCOMING_SHIPMENTS: "INCOMING_SHIPMENTS",
  OUTCOMING_SHIPMENTS: "OUTCOMING_SHIPMENTS",
};

export default WarehouseView;